import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

// Rótulos e tons dos valores técnicos da Solicitação de conta (U19, U33). Arquivo leve: entra no
// `validateSearch` da rota (filtros), que vai para o JS inicial.

/** `optionsBankAccNewStatus` (contexts/bankAccount/bankAccountOptions.ts:50-103), na ordem de lá. */
export const BANK_ACCOUNT_REQUEST_STATUS = defineEnum({
  Active: { label: msg`Ativa`, tone: 'ok', icon: 'circle-check' },
  Approval: { label: msg`Aprovação`, tone: 'info', icon: 'shield-check' },
  Processing: { label: msg`Abertura`, tone: 'info', icon: 'hourglass' },
  Signatures: { label: msg`Assinatura`, tone: 'warn', icon: 'pen-line' },
  SignaturesValidation: { label: msg`Validação de Assinatura`, tone: 'info', icon: 'badge-check' },
  InstrumentApproval: { label: msg`Aprovação de Instrumento`, tone: 'info', icon: 'file-check' },
  Cancel: { label: msg`Cancelado`, tone: 'neutral', icon: 'ban' },
  Timeout: { label: msg`Expirado`, tone: 'err', icon: 'hourglass' },
  Closed: { label: msg`Encerrado`, tone: 'neutral', icon: 'check-check' },
  Draft: { label: msg`Rascunho`, tone: 'neutral', icon: 'pencil' },
  Revision: { label: msg`Revisão`, tone: 'warn', icon: 'rotate-ccw' },
  OpeningAccountRevision: { label: msg`Revisão de Abertura de Conta`, tone: 'warn', icon: 'rotate-ccw' },
  CorbanPreAnalysis: { label: msg`Pré-Análise Corban`, tone: 'info', icon: 'scale' },
});

/** Status que o legado conhece fora do filtro (ButtonsOfActions.tsx:29, isReadOnly): só o tom. */
export const EXTRA_STATUS_TONES = defineEnum({
  ValidatingBcProtege: { label: msg`Validação BC Protege`, tone: 'info', icon: 'shield-check' },
  Disapproved: { label: msg`Reprovado`, tone: 'err', icon: 'circle-x' },
  Error: { label: msg`Erro`, tone: 'err', icon: 'triangle-alert' },
});

/** `typeAccountRequest` do filtro (components/DataTableFilters/BankAccountFilters/constants.ts:42-47). */
export const ACCOUNT_TYPE_FILTER = defineEnum({
  Escrow: { label: msg`Conta escrow` },
  Payment: { label: msg`Conta de pagamento` },
  EscrowPlus: { label: msg`Escrow +` },
  EscrowMulticreditors: { label: msg`Escrow multicredores` },
});

/** `typeAccount` do formulário (Tabs/InformationTab.tsx:55-63): rótulos diferentes do filtro. */
export const ACCOUNT_TYPE = defineEnum({
  Payment: { label: msg`Conta Livre Movimentação` },
  Escrow: { label: msg`Conta Escrow` },
  EscrowPlus: { label: msg`Escrow +` },
  EscrowMulticreditors: { label: msg`Escrow Multicredores` },
});

/** "Motivo para abrir a conta" (Tabs/InformationTab.tsx:203-219). */
export const OPENING_REASON = defineEnum({
  Debit: { label: msg`Cartão de débito corporativo` },
  Credit: { label: msg`Crédito` },
  Invoice: { label: msg`Emitir boletos de cobrança` },
  Transfer: { label: msg`Receber e enviar transferências e pagar boletos` },
  Others: { label: msg`Outros` },
});

/** Nível de permissão do operador (InvolvedBankAccRequestForm.tsx:188-198, AccountOperatorsForm.tsx:38-47). */
export const OPERATOR_LEVEL = defineEnum({
  Viewer: { label: msg`Visualizador` },
  JointApprover: { label: msg`Aprovador em Conjunto` },
  MasterApprover: { label: msg`Aprovador Master` },
  Requester: { label: msg`Solicitante` },
});

/** "Tipo de bloqueio" do reprovar e do cancelar (ApproveAndDisapproveForm.tsx:48-57). */
export const BLOCK_TYPE = defineEnum({
  Adjustable: { label: msg`Ajustável` },
  Final: { label: msg`Final` },
});

/** `manualUpdateOptions` (contexts/creditNote/creditNoteOptions.ts:176-180). */
export const MANUAL_UPDATE_ACTION = defineEnum({
  None: { label: msg`Não` },
  EndCurrent: { label: msg`Encerrar etapa atual` },
  EndAndCreateNew: { label: msg`Encerrar etapa atual e iniciar nova` },
});

/** `optionsBankAccNewTimeLine` (contexts/bankAccount/bankAccountOptions.ts:2-48). */
export const TIMELINE_STEP = defineEnum({
  BankAccountApprove: { label: msg`Aprovação Abertura de Conta Bancaria` },
  Signature: { label: msg`Assinatura` },
  BankAccountOpen: { label: msg`Abertura de conta` },
  Cancel: { label: msg`Cancelada` },
  Finished: { label: msg`Encerrado` },
  Draft: { label: msg`Rascunho` },
  Disapproved: { label: msg`Reprovado` },
  Revision: { label: msg`Revisão` },
  BankAccountRequestRevision: { label: msg`Revisão de Conta Bancária` },
  ApprovedBankAccountRequestRevision: { label: msg`Revisão de Conta Bancária Aprovada` },
  RevisionOpenBankAccount: { label: msg`Revisão de abertura` },
});

/** "Tipo de permissão" do compartilhar (components/ShareRecords/ShareRecord.tsx:28-32). */
export const PRINCIPAL_TYPE = defineEnum({
  User: { label: msg`Usuário` },
  Group: { label: msg`Grupo` },
  Tenant: { label: msg`Tenant` },
});

/** "Nível de permissão" do compartilhar (ShareRecord.tsx:54-57). */
export const SHARE_LEVEL = defineEnum({
  View: { label: msg`Visualizar` },
  Edit: { label: msg`Editar` },
});

/** Rótulo do tipo de restrição (`attributesTypeFormat`, helpers/formats/StringFormats.ts:12-21). */
export const RESTRICTION_TYPE = defineEnum({
  // O legado não tem rótulo para `registrationnumber` e mostra vazio; aqui sai "CPF/CNPJ" (relatório, ⚠️).
  registrationnumber: { label: msg`CPF/CNPJ` },
  email: { label: msg`Email` },
  zipcode: { label: msg`CEP` },
  documentnumber: { label: msg`RG` },
  phone: { label: msg`Telefone` },
  ispb: { label: msg`ISPB` },
});
